import { injectable } from 'tsyringe'
import { LoginRequestInterface } from '@/data/payload/contracts/AuthRequest'
import { AuthApiRepository } from '@/app/repositories/api/AuthApiRepository'
import { Admin } from '@/domain/entities/Admin'

@injectable()
export class AuthPresenter {
  private repository: AuthApiRepository

  constructor(repository: AuthApiRepository) {
    this.repository = repository
  }

  public onLogin(payload: LoginRequestInterface): Promise<Admin> {
    return this.repository.login(payload)
  }
}
